import { HStack, SearchIcon, Text } from 'native-base';
import React from 'react';
import { StyleSheet } from 'react-native';
import { UploadCloudIcon } from '../../assets';
import IconButton from '../IconButton';
const styles = StyleSheet.create({
  formFileUpload: {
    textAlign: 'center',
    borderRadius: 4,
    backgroundColor: '#F1F4F7',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 2,
    width: '100%'
  },
  inputFileUpload: {
    display: 'none'
  }
});
const DragDropFileAndBrowse = _ref => {
  let {
    validateFile,
    showDragDrop = true
  } = _ref;
  const inputRef = React.useRef(null);
  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      validateFile(file);
    }
  };
  const onHandleBrowse = e => {
    e.preventDefault();
    e.stopPropagation();
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      validateFile(file);
    }
  };
  return /*#__PURE__*/React.createElement("form", {
    style: {
      ...styles.formFileUpload,
      ...{
        height: showDragDrop ? '219px' : '0'
      }
    },
    onDragOver: handleDrop,
    onDrop: handleDrop,
    onSubmit: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    type: "file",
    multiple: true,
    onChange: onHandleBrowse,
    style: styles.inputFileUpload
  }), /*#__PURE__*/React.createElement(HStack, {
    height: '100%',
    space: 2,
    justifyContent: "center",
    alignItems: "center",
    accessibilityLabel: 'Drag&Drop_DocumentUploadBox',
    testID: 'Drag&Drop_DocumentUploadBox'
  }, showDragDrop ? /*#__PURE__*/React.createElement(HStack, {
    space: 2,
    justifyContent: "center",
    alignItems: "center",
    accessibilityRole: "text",
    accessibilityLabel: 'Drag & Drop File',
    testID: 'Drag&Drop_FileLabel'
  }, /*#__PURE__*/React.createElement(UploadCloudIcon, {
    color: "#0a4a8d"
  }), /*#__PURE__*/React.createElement(Text, {
    fontSize: "sm",
    fontWeight: "bold",
    lineHeight: "md",
    color: "text.running"
  }, "Drag & Drop File"), /*#__PURE__*/React.createElement(Text, {
    fontSize: "sm",
    fontWeight: "medium",
    color: "text.running",
    mr: 1
  }, "OR")) : null, /*#__PURE__*/React.createElement(IconButton, {
    accessibilityLabel: 'click browse button',
    accessibilityRole: "button",
    testID: 'Browse_DocumentUploadBox_Web',
    title: 'BROWSE',
    w: {
      base: 'full',
      md: 202,
      lg: 202
    },
    onPress: () => {
      if (inputRef && inputRef.current) {
        //@ts-ignore
        inputRef.current.click();
      }
    },
    Icon: /*#__PURE__*/React.createElement(SearchIcon, {
      size: '5',
      color: "#ffffff"
    })
  })));
};
export default /*#__PURE__*/React.memo(DragDropFileAndBrowse);
//# sourceMappingURL=index.js.map